export default `
CREATE VIRTUAL TABLE File_fts USING fts5(
  id UNINDEXED,
  workspace_id UNINDEXED,
  name
);

INSERT INTO File_fts (id, workspace_id, name)
SELECT id, workspace_id, name FROM File;

CREATE VIRTUAL TABLE Project_fts USING fts5(
  id UNINDEXED,
  workspace_id UNINDEXED,
  name
);

INSERT INTO Project_fts (id, workspace_id, name)
SELECT id, workspace_id, name FROM Project;

CREATE VIRTUAL TABLE Comment_fts USING fts5(
  id UNINDEXED,
  workspace_id UNINDEXED,
  text
);

INSERT INTO Comment_fts(id, workspace_id, text)
SELECT id, workspace_id, text FROM Comment;
`;
